var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 6.75C26.8862 6.75151 23.8306 7.59506 21.157 9.19131C18.4834 10.7876 16.2912 13.0771 14.8125 15.8175C13.0922 15.6398 11.3537 15.8139 9.70278 16.3293C8.05186 16.8447 6.52306 17.6906 5.20939 18.8155C3.89572 19.9404 2.82464 21.3208 2.06132 22.8727C1.298 24.4247 0.858401 26.1157 0.769265 27.8429C0.680129 29.5701 0.943321 31.2974 1.54283 32.9196C2.14234 34.5419 3.06562 36.0252 4.25652 37.2794C5.44741 38.5335 6.88102 39.5323 8.47011 40.2149C10.0592 40.8975 11.7705 41.2497 13.5 41.25H30C34.575 41.25 38.9626 39.4326 42.1976 36.1976C45.4326 32.9626 47.25 28.575 47.25 24C47.25 19.425 45.4326 15.0374 42.1976 11.8024C38.9626 8.56741 34.575 6.75 30 6.75ZM30 36.75H13.5C11.312 36.7953 9.19561 35.9695 7.61644 34.4543C6.03727 32.9391 5.12467 30.8587 5.07942 28.6706C5.03417 26.4826 5.85996 24.3662 7.37514 22.787C8.89032 21.2078 10.9708 20.2953 13.1588 20.25C12.8857 21.4813 12.7486 22.7388 12.75 24C12.75 24.5967 12.9871 25.169 13.4091 25.591C13.831 26.0129 14.4033 26.25 15 26.25C15.5968 26.25 16.1691 26.0129 16.591 25.591C17.013 25.169 17.25 24.5967 17.25 24C17.25 21.4783 17.9978 19.0132 19.3988 16.9165C20.7998 14.8198 22.7911 13.1856 25.1208 12.2205C27.4506 11.2555 30.0142 11.003 32.4874 11.495C34.9607 11.9869 37.2325 13.2013 39.0157 14.9844C40.7988 16.7675 42.0131 19.0393 42.5051 21.5126C42.997 23.9859 42.7445 26.5495 41.7795 28.8792C40.8145 31.209 39.1803 33.2002 37.0836 34.6012C34.9868 36.0022 32.5218 36.75 30 36.75Z",
    fill: "url(#paint0_linear_1559_7157)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_7157",
    x1: 24.0012,
    y1: 6.75,
    x2: 24.0012,
    y2: 41.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.0a38b8d8ffa2637d478c0ec1c0dfbf59.svg";
export { ForwardRef as ReactComponent };